<div class="card">
  <div class="card-title-container">
    <ng-content select="[card-image]"></ng-content>
  <div class="card-title">
    <ng-content select="[card-title]"></ng-content>
  </div>
  </div>
  <div class="card-content">
    <ng-content select="[card-content]"></ng-content>
  </div>
  <div class="card-actions">
    <ng-content select="[card-actions]"></ng-content>
  </div>


</div>

